import { useStorage } from '@vueuse/core';

// Singleton state
const isCollapsed = useStorage('next-sidebar-collapsed', false, localStorage);

export function useSidebar() {
  const toggleSidebar = () => {
    isCollapsed.value = !isCollapsed.value;
  };

  const setCollapsed = value => {
    isCollapsed.value = value;
  };

  return {
    isCollapsed,
    toggleSidebar,
    setCollapsed,
  };
}
